import clsx from 'clsx';
import {useSelector} from 'react-redux';

import AemImage from '@/components/AemImage/AemImage';
import {selectIsEmbedded} from '@/state/selectors/app';
import type {ImageModel} from '@/types/content';

type SmallCardContentProps = {
    title?: string;
    imageMedia?: ImageModel[];
    borderless: boolean;
};

const SmallCardContent = ({title, imageMedia, borderless}: SmallCardContentProps) => {
    const isEmbedded = useSelector(selectIsEmbedded);

    return (
    <>
        <h2
            className={clsx(
                'm-0 font-bold text-lg text-white',
                borderless && 'px-4'
            )}
        >
            {title}
        </h2>

        {imageMedia && imageMedia.length > 0 && (
            <div
                className={clsx(
                    'mt-auto flex w-full shrink-0 items-center justify-center overflow-hidden pt-4',
                    isEmbedded && 'h-32',
                    !borderless && 'rounded-2xl'
                )}
            >
                <AemImage
                    imageMedia={imageMedia}
                    className={clsx(isEmbedded ? 'flex items-center justify-center' : 'h-full w-full')}
                    pictureClassName={clsx(isEmbedded ? 'flex items-center justify-center' : 'h-full w-full')}
                    imgClassName={clsx(
                        'object-contain',
                        isEmbedded ? 'h-auto max-h-28 w-auto max-w-full' : 'h-full w-full max-h-full max-w-full'
                    )}
                />
            </div>
        )}
    </>
    );
};

export default SmallCardContent;
